export const AI_TRANSLATIONS = {
  en: {
    title: "Teknik AI Assistant",
    tagline: "Ask about workholding for your parts",
    welcome:
      "Hello! Describe your component and machining setup — I'll suggest the right clamping approach from our principals (Rudra Magnets, EROWA, SPREITZER).",
    placeholder: "e.g. I need to grind thin stainless shims without distortion…",
    send: "Send",
    thinking: "Thinking…",
    error: "The assistant is unavailable right now. Please try again shortly.",
    suggestions: [
      "Which chuck for thin-wall aerospace parts?",
      "Zero-point clamping for EDM — how does it work?",
      "Fast changeover vice for 5-axis milling?",
    ],
    analysisBtn: "AI Feasibility Snapshot",
    analysisTitle: "AI Feasibility Snapshot",
    analysisDisclaimer: "Indicative only — our engineers confirm feasibility within one working day.",
    powered: "Powered by Gemini",
  },
  hi: {
    title: "टेकनिक AI सहायक",
    tagline: "अपने पार्ट्स के वर्कहोल्डिंग के बारे में पूछें",
    welcome:
      "नमस्ते! अपना कंपोनेंट और मशीनिंग सेटअप बताइए — मैं हमारे प्रिंसिपल्स (Rudra Magnets, EROWA, SPREITZER) में से सही क्लैंपिंग तरीका सुझाऊँगा।",
    placeholder: "उदा. पतले स्टेनलेस शिम बिना डिस्टॉर्शन ग्राइंड करने हैं…",
    send: "भेजें",
    thinking: "विचार हो रहा है…",
    error: "सहायक अभी उपलब्ध नहीं है। कृपया कुछ देर बाद कोशिश करें।",
    suggestions: [
      "थिन-वॉल एयरोस्पेस पार्ट्स के लिए कौन सा चक?",
      "EDM में ज़ीरो-पॉइंट क्लैंपिंग कैसे काम करती है?",
      "5-एक्सिस मिलिंग के लिए तेज़ चेंजओवर वाइस?",
    ],
    analysisBtn: "AI फ़ीज़िबिलिटी स्नैपशॉट",
    analysisTitle: "AI फ़ीज़िबिलिटी स्नैपशॉट",
    analysisDisclaimer: "केवल संकेतात्मक — हमारे इंजीनियर एक कार्य-दिवस में पुष्टि करेंगे।",
    powered: "Gemini द्वारा संचालित",
  },
  mr: {
    title: "टेकनिक AI सहाय्यक",
    tagline: "तुमच्या भागांसाठी वर्कहोल्डिंगबद्दल विचारा",
    welcome:
      "नमस्कार! तुमचा घटक आणि मशीनिंग सेटअप सांगा — आमच्या प्रिन्सिपल्समधून (Rudra Magnets, EROWA, SPREITZER) योग्य क्लॅम्पिंग पद्धत सुचवेन.",
    placeholder: "उदा. पातळ स्टेनलेस शिम विकृतीशिवाय ग्राइंड करायचे आहेत…",
    send: "पाठवा",
    thinking: "विचार सुरू आहे…",
    error: "सहाय्यक सध्या उपलब्ध नाही. कृपया थोड्या वेळाने पुन्हा प्रयत्न करा.",
    suggestions: [
      "थिन-वॉल एरोस्पेस भागांसाठी कोणते चक?",
      "EDM मध्ये झिरो-पॉइंट क्लॅम्पिंग कशी चालते?",
      "5-अॅक्सिस मिलिंगसाठी जलद बदल व्हाइस?",
    ],
    analysisBtn: "AI फिजिबिलिटी स्नॅपशॉट",
    analysisTitle: "AI फिजिबिलिटी स्नॅपशॉट",
    analysisDisclaimer: "केवळ संकेतस्वरूप — आमचे अभियंता एका कार्य-दिवसात खात्री करतील.",
    powered: "Gemini द्वारे समर्थित",
  },
};
